module.exports = __webpack_public_path__ + "img/chat_bot.b0f54705.png";